import React from "react";
import ButtonBasic from "./ButtonBasic";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";

export default function ButtonSubmit({ id = 'deq-primary', label = 'Submit', cypressid = 'submit', ...props }) {
  return (
    <ButtonBasic type='submit' id={id} cypressid={cypressid} {...props}>
      {label}
      <FontAwesomeIcon className='font-icon' icon={faPaperPlane} aria-hidden="true" />
    </ButtonBasic>
  );
}
